module.exports = __webpack_public_path__ + "static/media/quick-view-inactive.a3d489bd.svg";